import React, {useMemo, useState} from 'react';
import {
    MaterialReactTable,
    type MRT_ColumnDef,
    type MRT_ColumnFiltersState,
    useMaterialReactTable,
} from 'material-react-table';
import {Box, Button, Stack} from '@mui/material';
import {useGetAllReportCliIns} from "./Services";
import {ReportCliIns} from "./types";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ReportCliInsExp from "./ReportCliInsExp";
import {useTabSettings} from "../../common/Services";

interface ListaReportCliInsProps {
}


const ListaReportCliIns: React.FC<ListaReportCliInsProps> = () => {

  const [globalFilter, setGlobalFilter] = useState('');

  const keyusername = localStorage.getItem('keyusername') || 'NN';
  const { columnVisibility,  setColumnVisibility,  columnFilters, setColumnFilters,  sorting,  setSorting, pagination,  setPagination,  saveTabSettings,} = useTabSettings('ListaReportCliIns', keyusername);



  const [draftColumnFilters, setDraftColumnFilters] = useState<MRT_ColumnFiltersState>(columnFilters);

  const {  data: { results = [], count } = {} , isFetching, isLoading,  isError} = useGetAllReportCliIns(pagination,columnFilters,globalFilter,sorting);

  const [isDialogExporterOpen, setIsDialogExporterOpen] = useState(false);

  // const [isDialogReportCliInsExpPDF, setIsDialogReportCliInsPDF] = useState(false);
  // const [isDialogReportCliInsExpXLS, setIsDialogReportCliInsXLS] = useState(false);







  const columns = useMemo<MRT_ColumnDef<ReportCliIns>[]>(
    () => [
  // {
  //   accessorKey: 'id',
  //   header: 'ID',
  //   size: 5,
  //   enableEditing: false,
  // },

  //   {
  //   accessorKey: 'ditta',
  //   header: 'Cod.Ditta',
  //   size: 5,
  //   enableEditing: false,
  // },

  {
    accessorKey: 'nomeditta',
    header: 'Ditta',
    size: 5,
    enableEditing: false,
    Cell: ({ cell }) => {
      const value = (cell.getValue() ?? '') as string;
      return (
        <span title={value}>
          {value.length > 25 ? `${value.substring(0, 25)}...` : value}
        </span>
      );
    },
  },

  {
    accessorKey: 'codcli',
    header: 'Cod. Cliente',
    size: 5,
    enableEditing: false,
  },

  {
    accessorKey: 'ragsoccli',
    header: 'Cliente',
    size: 10,
    enableEditing: false,
    Cell: ({ cell }) => {
      const value = (cell.getValue() ?? '') as string;
      return (
        <span title={value}>
          {value.length > 30 ? `${value.substring(0, 30)}...` : value}
        </span>
      );
    },
  },

  {
    accessorKey: 'indcliblocdesc',
    header: 'Sosp.Cliente',
    size: 5,
    enableEditing: false,
    Cell: ({ cell }) => {
      const value = (cell.getValue() ?? '') as string;
      return (
        <span title={value}>
          {value.length > 40 ? `${value.substring(0, 40)}...` : value}
        </span>
      );
    },
  },

  {
    accessorKey: 'nomeagente',
    header: 'Agente',
    size: 8,
    enableEditing: false,
    Cell: ({ cell }) => {
      const value = (cell.getValue() ?? '') as string;
      return (
        <span title={value}>
          {value.length > 20 ? `${value.substring(0, 20)}...` : value}
        </span>
      );
    },
  },
    ],
    [],
  );





  const table = useMaterialReactTable({
    columns,
    data: results,
    initialState: { density: 'compact' },

    manualFiltering: true, //turn off built-in client-side filtering
    manualPagination: true, //turn off built-in client-side pagination
    manualSorting: true, //turn off built-in client-side sorting

    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)

    enableEditing: false,
    enableRowActions: false,
    enableColumnActions: false,

    //getRowId: (row) => row.id.toString(),

    // getRowId: (row) => (row.id ? row.id.toString() : ''),

    getRowId: (row) => (row.id ? row.id.toString() : ''),

    muiToolbarAlertBannerProps: isError ? {
          color: 'error',
          children: 'Error loading data',
        } : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
      },
    },
    // muiEditRowDialogProps: {
    //    fullWidth: true,
    //    maxWidth: 'md',
    //  },
    // onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setDraftColumnFilters,
    // onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    // onCreatingRowCancel: () => setValidationErrors({}),
    // onEditingRowCancel: () => setValidationErrors({}),

    // onColumnFiltersChange: (updater) => {
    //   const newFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
    //   setColumnFilters(newFilters);
    //   saveTabSettings(columnVisibility, newFilters, sorting, pagination);
    // },
    onSortingChange: (updater) => {
      const newSorting = typeof updater === 'function' ? updater(sorting) : updater;
      setSorting(newSorting);
      saveTabSettings(columnVisibility, columnFilters, newSorting, pagination);
    },
    onPaginationChange: (updater) => {
      const newPagination = typeof updater === 'function' ? updater(pagination) : updater;
      setPagination(newPagination);
      saveTabSettings(columnVisibility, columnFilters, sorting, newPagination);
    },

    onColumnVisibilityChange: (updater) => {
      const newVisibility = typeof updater === 'function' ? updater(columnVisibility) : updater;
      setColumnVisibility(newVisibility);
      saveTabSettings(newVisibility, columnFilters, sorting,pagination);
    },

  renderTopToolbarCustomActions: ({ table }) => (

    <>
                <Stack
                  direction="row"
                  spacing={0}
                  sx={{
                    width: '60%',
                    padding: '4px',
                    alignItems: 'center',
                  }}
                >

              <Box sx={{ width: '25%' }} />

              <Box sx={{ width: '25%' }} />


              <Box sx={{ width: '25%'  }}>
                <Button
                  variant="contained"
                  onClick={() => setIsDialogExporterOpen(true)}
                  startIcon={<FileDownloadIcon />}
                  sx={{ width: 160 }}
                >
                  EXPORT DATI
                </Button>

                {isDialogExporterOpen && (
                  <ReportCliInsExp
                      pagination={pagination}
                      columnFilters={columnFilters}
                      globalFilter={globalFilter}
                      sorting={sorting}
                      columnVisibility={columnVisibility}
                      columns={columns}
                      onClose={() => setIsDialogExporterOpen(false)}
                  />
                )}
              </Box>

              {/* Slot 3: Applica Filtri */}
              <Box sx={{ width: '25%'}}>
                <Button
                  variant="contained"
                  onClick={() => {
                      setColumnFilters([...draftColumnFilters]); // 🔥 CLONE
                      saveTabSettings(columnVisibility, draftColumnFilters, sorting, pagination);
                    }}
                  sx={{ width: 160 }}
                >
                  Applica Filtri
                </Button>
              </Box>

            </Stack>

   </>
   ),


    //rowCount: meta?.totalRowCount ?? 0,
    rowCount: count ?? 0,

    state: {
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      columnVisibility,
      isLoading: isLoading,
      // isSaving: isDeletingReportCliIns,
      showAlertBanner: isLoading,
      showProgressBars: isFetching,
    },
  });

 // return (
 //
 //     <Box sx={{ mt: "60px" }}>
 //      {isLoadingReportCliIns ? (
 //        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "500px" }}>
 //          <CircularProgress size={80} />
 //        </Box>
 //      ) : (
 //        <MaterialReactTable table={table} />
 //      )}
 //    </Box>
 //
 //  );
 //
 return (

     <Box sx={{ mt: "60px" }}>
              <MaterialReactTable table={table} />
    </Box>

  );


};


export default ListaReportCliIns;

